module.exports = __webpack_public_path__ + "static/media/lct2.fb564b8d.png";